import { isRealSection } from "../types/Data";
import { useCustomParams } from "./useCustomParams";

/**
 * Checks whether current page is an article page.
 */
export const useIsArticlePage = () => {
  const { level1 = "", level2 = "", level3 } = useCustomParams();

  return isRealSection(level1) && level2 && !level3;
};
